/*
 * @Author: your name
 * @Date: 2020-03-21 13:07:20
 * @LastEditTime: 2021-10-13 14:52:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\router\index.js
 */ 
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
const commonRoutes = [
    {
        path: '/',
        redirect: '/index',
    }, {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index.vue'),
    }, {
        // 单点登录中转页
        path: '/sso/login',
        name: 'singleSignOn',
        component: () => import('@/views/sso/login.vue'),
    },
];

const createRouter = () =>
    new VueRouter({
        routes: commonRoutes,
        mode: 'history',
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;
